import { statusMap } from "../utils/helpers";

const Badge = ({ st }) => {
  const s = statusMap[st] || statusMap.READY;
  return <span style={{ background: s.bg, color: s.color, padding: "2px 10px", borderRadius: 12, fontSize: 11, fontWeight: 600, whiteSpace: "nowrap" }}>{s.label}</span>;
};

export default Badge;
